export default "<p>\n  test works!\n</p>\n\n\n<button  type=\"button\" pButton icon=\"fa-edit\"  class=\"ui-button-primary\"></button>\n\n"